export const SERVICES = {
  services: {
    performanceImprovement: {
      children: {
        acrobatics: '',
        bikiniFitness: '',
        bodybuilding: '',
        callisthenics: '',
        competitionCoaching: '',
        crossfit: '',
        enduranceSports: '',
        fitness: '',
        functionalTraining: '',
        fustra: '',
        gymnastics: '',
        gymTraining: '',
        handstanding: '',
        highIntensityIntervalTraining: '',
        hydrobics: '',
        hydroRunning: '',
        kettlebell: '',
        martialArts: '',
        methodMakia: '',
        methodPutkisto: '',
        movement: '',
        movementImpaired: '',
        others: '',
        otherSports: '',
        pilates: '',
        postPregnancy: '',
        powerLifting: '',
        pregnancyTimeTraining: '',
        remoteTraining: '',
        running: '',
        seniorCitizens: '',
        swimming: '',
        therapeutic: '',
        weightlifting: '',
        yoga: '',
        meditation: '',
        mentalCoaching: '',
        mindfulness: '',
        nutritionPrograms: '',
        physiotherapy: '',
        strengthAndMuscle: '',
        stressControl: '',
        weightLoss: '',
        wellness: '',
        performanceImprovement: ''
      }
    },
    weightLoss: {
      children: {
        acrobatics: '',
        bikiniFitness: '',
        bodybuilding: '',
        callisthenics: '',
        crossfit: '',
        enduranceSports: '',
        fitness: '',
        functionalTraining: '',
        fustra: '',
        gymnastics: '',
        gymTraining: '',
        handstanding: '',
        highIntensityIntervalTraining: '',
        hydrobics: '',
        hydroRunning: '',
        kettlebell: '',
        martialArts: '',
        mentalCoaching: '',
        methodMakia: '',
        methodPutkisto: '',
        mindfulness: '',
        movement: '',
        movementImpaired: '',
        nutritionPrograms: '',
        others: '',
        otherSports: '',
        pilates: '',
        postPregnancy: '',
        powerLifting: '',
        pregnancyTimeTraining: '',
        running: '',
        seniorCitizens: '',
        stressControl: '',
        swimming: '',
        therapeutic: '',
        weightlifting: '',
        yoga: '',
        competitionCoaching: '',
        fodmap: '',
        glutenFree: '',
        milkFree: '',
        paleo: '',
        vegetarian: '',
        meditation: '',
        physiotherapy: '',
        wellness: ''
      }
    },
    strengthAndMuscle: {
      children: {
        acrobatics: '',
        bikiniFitness: '',
        bodybuilding: '',
        callisthenics: '',
        competitionCoaching: '',
        crossfit: '',
        fitness: '',
        functionalTraining: '',
        fustra: '',
        gymnastics: '',
        gymTraining: '',
        handstanding: '',
        highIntensityIntervalTraining: '',
        kettlebell: '',
        mentalCoaching: '',
        methodMakia: '',
        methodPutkisto: '',
        movement: '',
        movementImpaired: '',
        nutritionPrograms: '',
        others: '',
        otherSports: '',
        physiotherapy: '',
        pilates: '',
        postPregnancy: '',
        powerLifting: '',
        pregnancyTimeTraining: '',
        seniorCitizens: '',
        therapeutic: '',
        weightlifting: '',
        yoga: '',
        enduranceSports: '',
        fodmap: '',
        glutenFree: '',
        milkFree: '',
        paleo: '',
        stressControl: '',
        vegetarian: '',
        weightLoss: '',
        wellness: '',
        hydrobics: '',
        hydroRunning: '',
        meditation: '',
        mindfulness: ''
      }
    },
    wellness: {
      children: {
        fustra: '',
        meditation: '',
        mentalCoaching: '',
        methodMakia: '',
        methodPutkisto: '',
        mindfulness: '',
        movement: '',
        movementImpaired: '',
        nutritionPrograms: '',
        others: '',
        otherSports: '',
        physiotherapy: '',
        pilates: '',
        postPregnancy: '',
        pregnancyTimeTraining: '',
        running: '',
        seniorCitizens: '',
        stressControl: '',
        therapeutic: '',
        weightLoss: '',
        wellness: '',
        yoga: '',
        performanceImprovement: ''
      }
    }
  }
}
